module.exports = __webpack_public_path__ + "img/scrapbox_favicon.9475d358.png";